export type Role = 'viewer' | 'operator' | 'admin';

const RANK: Record<Role, number> = { viewer: 0, operator: 1, admin: 2 };

/** UI hint only; the BFF enforces roles on every request. */
export function hasRole(actual: Role | undefined, required: Role): boolean {
  return actual !== undefined && RANK[actual] >= RANK[required];
}
